import { Select } from "antd";
const { Option } = Select;

const MultiSelectInput = ({ title, options, value, onChange, placeholder }) => {
  return (
    <div>
      <label className="font-semibold" style={{ fontWeight: 600 }}>{title}</label>
      <Select
        mode="multiple"
        style={{ width: "100%", marginTop: "8px" }}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        allowClear
        optionLabelProp="label"
      >
        {options?.map((option) => (
          <Option key={option.value} value={option.value} label={option.label}>
            {option.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default MultiSelectInput;
